import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import appReducer from "./app";
import dataReducer from "./data";
import historyReducer from "./history";
import scheduleReducer from "./schedule";
import sessionReducer from "./session";
import userReducer from "./user";

const createRootReducer = history => {
  const reducerBase = combineReducers({
    router: connectRouter(history),
    app: appReducer,
    data: dataReducer,
    history: historyReducer,
    schedule: scheduleReducer,
    session: sessionReducer,
    user: userReducer
  });

  const rootReducer = (state, action) => {
    if (action.type === "RESET_APP") {
      state = undefined;
    }

    return reducerBase(state, action);
  };

  return rootReducer;
};

export default createRootReducer;
